import React from 'react'
import LoginMain from '../components/login/LoginMain'

function Login() {
  return (
    <div>
      <LoginMain/>
    </div>
  )
}

export default Login